export default "__VITE_ASSET__1a2a160b__"